import {
  Component,
  OnInit,
  ViewEncapsulation,
  ViewChild,
  ElementRef,
  AfterViewInit,
} from '@angular/core';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { PlessAlert } from './../../../shared/pless-alert/pless-alert.component';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW4701Model } from './kymw4701.model';
import { GetMultiGoodsService } from './api-services/get-multi-goods.service';
import { GetCandidateGoodsService } from './api-services/get-candidate-goods.service';
import { GetMultiCodeInfoService } from './api-services/get-multi-code-info.service';
import { RegistMultiGoodsService } from './api-services/regist-multi-goods.service';
import { DeleteMultiGoodsService } from './api-services/delete-multi-goods.service';
import { FlexGrid, CellRangeEventArgs, CellType } from '@grapecity/wijmo.grid';
import { EventArgs } from '@grapecity/wijmo';
import { DataGridUtil } from '../../../commons/kymw00/data-grid-util';
import { Menu } from '@grapecity/wijmo.input';
import { GetMultiGoodsResponse } from './api-services/get-multi-goods.service';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';

/**
 * マルチ商品設定画面を管理するクラス
 *
 * @export KYMW4701Component
 * @class KYMW4701Component
 */
@Component({
  selector: 'app-kymw4701',
  templateUrl: 'kymw4701.component.html',
  styleUrls: ['kymw4701.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class KYMW4701Component
  extends PlessViewHelperSub
  implements OnInit, AfterViewInit
{
  @ViewChild('dtg_MultiGoodsList', { static: false })
  dtg_MultiGoodsList: FlexGrid;
  @ViewChild('dtg_CandidateGoodsList', { static: false })
  dtg_CandidateGoodsList: FlexGrid;

  model: KYMW4701Model = new KYMW4701Model();

  // コンテキストメニュー マルチコード
  contextForMultiGoodsList: Menu;
  // コンテキストメニュー 候補商品
  contextForCandidateGoodsList: Menu;
  // 親画面への連携用
  setKYMW4701Parameter: Function;

  private dragIndex: number;
  private isEdited = false;

  iconQuestion = faQuestionCircle;

  /**
   *Creates an instance of KYMW4701Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW4701Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    public elementRef: ElementRef,
    private getMultiGoodsService: GetMultiGoodsService,
    private getCandidateGoodsService: GetCandidateGoodsService,
    private getMultiCodeInfoService: GetMultiCodeInfoService,
    private registMultiGoodsService: RegistMultiGoodsService,
    private deleteMultiGoodsService: DeleteMultiGoodsService
  ) {
    super(kymw00Model);
  }

  /**
   * 親画面に対して公開し、親画面からのパラメータを受け取るためのメソッド
   *
   * @param {*} param 受け渡されるデータ
   * @memberof KYMW4701Component
   */
  public setInterfaceParam(
    param: { multiCode: string } | { pcode: string }
  ): void {
    if ('multiCode' in param) this.model.paramMultiCode = param.multiCode;
    if ('pcode' in param) this.model.paramPcode = param.pcode;
  }

  /**
   * 初期処理
   *
   * @memberof KYMW4701Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW4701';

    // コンテキストメニュー表示
    this.createContextMenuForMulti();
    this.createContextMenuForCandidate();

    // 候補商品情報取得コールバック
    const calbakCandidateGoods = () => {
      this.getCandidateGoodsService.execute(this.model);
      this.model.commonCatchcopyOrigin = this.model.commonCatchcopy;
      this.model.commonGoodsExplanationOrigin =
        this.model.commonGoodsExplanation;
    };

    // マルチ商品情報取得
    if (this.model.paramMultiCode) {
      // 呼び出し元 マルチコード一覧
      this.getMultiGoodsService.execute(this.model, calbakCandidateGoods);
    } else if (this.model.paramPcode) {
      // 呼び出し元 商品マスタ
      this.getMultiGoodsService.execute(this.model, calbakCandidateGoods);
    }
  }

  /**
   * ビュー初期化
   *
   * @memberof KYMW4700Component
   */
  public ngAfterViewInit(): void {
    // Grid 無選択
    if (this.dtg_MultiGoodsList) {
      this.dtg_MultiGoodsList.rowHeaders.columns[0].minWidth = 5;
      this.dtg_MultiGoodsList.itemsSourceChanged.addHandler(
        (_g: FlexGrid, _e: EventArgs) => _g.select(-1, -1)
      );
      this.dtg_MultiGoodsList.itemFormatter = (panel, r, c, cell) => {
        if (CellType.Cell === panel.cellType) {
          const item = this.model.multiGoodsList[r];
          if (
            item.ApplyTermEnd &&
            item.ApplyTermEnd < PlessViewUtilsSub.formatedNowDate('YYYYMMDD')
          )
            cell.classList.add('gray-out');
        }
      };
      this.dtg_MultiGoodsList.hostElement.addEventListener('contextmenu', e => {
        e.preventDefault();
        DataGridUtil.showContextMenu(
          this.dtg_MultiGoodsList,
          this.contextForMultiGoodsList,
          e
        );
      });
    }
    if (this.dtg_CandidateGoodsList) {
      this.dtg_CandidateGoodsList.itemsSourceChanged.addHandler(
        (_g: FlexGrid, _e: EventArgs) => _g.select(-1, -1)
      );
      this.dtg_CandidateGoodsList.itemFormatter = (panel, r, c, cell) => {
        if (CellType.Cell === panel.cellType) {
          const item = this.model.candidateGoodsList[r];
          if (
            item.ApplyTermEnd &&
            item.ApplyTermEnd < PlessViewUtilsSub.formatedNowDate('YYYYMMDD')
          )
            cell.classList.add('gray-out');
        }
      };
      this.dtg_CandidateGoodsList.hostElement.addEventListener(
        'contextmenu',
        e => {
          e.preventDefault();
          DataGridUtil.showContextMenu(
            this.dtg_CandidateGoodsList,
            this.contextForCandidateGoodsList,
            e
          );
        }
      );
    }
  }

  /**
   * ドラッグ開始イベント
   *
   * @param {FlexGrid} s
   * @param {CellRangeEventArgs} e
   */
  onDraggingRow(s: FlexGrid, e: CellRangeEventArgs) {
    this.dragIndex = e.row;
    s.collectionView.moveCurrentToPosition(this.dragIndex);
  }

  /**
   * ドラッグ終了イベント
   *
   * @param {FlexGrid} s
   * @param {CellRangeEventArgs} e
   */
  onDraggedRow(s: FlexGrid, e: CellRangeEventArgs) {
    let dropIndex = e.row,
      arr = s.collectionView.sourceCollection;
    s.collectionView.deferUpdate(() => {
      let item = arr[this.dragIndex];
      arr.splice(this.dragIndex, 1);
      arr.splice(dropIndex, 0, item);
      s.collectionView.moveCurrentToPosition(dropIndex);
      this.model.multiGoodsList.forEach(
        (e, i) => (e.PublishSeq = (i + 1).toString())
      );
      this.dtg_MultiGoodsList.collectionView.refresh();
    });
  }

  /**
   * コンテキストメニュー作成(マルチ商品一覧用)
   *
   * @memberof KYMW4701Component
   */
  private createContextMenuForMulti(): void {
    this.contextForMultiGoodsList = new Menu(document.createElement('div'), {
      displayMemberPath: 'caption',
      selectedValuePath: 'cmd',
      itemsSource: [{ caption: '行削除', cmd: 'delete', enabled: true }],
      command: {
        canExecuteCommand: param => {
          return param.enabled;
        },
      },
      itemClicked: () => {
        if (this.contextForMultiGoodsList.selectedValue === 'delete')
          this.delete();
      },
    });
  }

  /**
   * コンテキストメニュー押下処理(マルチ商品一覧用)
   *
   * @memberof KYMW4701Component
   */
  private delete() {
    this.isEdited = true;
    // 選択した行データを削除
    const selPcode = this.dtg_MultiGoodsList.selectedItems[0]?.PCode;
    this.model.multiGoodsList = this.model.multiGoodsList.filter(
      _ => selPcode !== _.PCode
    );
    this.model.multiGoodsList.forEach(
      (e, i) => (e.PublishSeq = (i + 1).toString())
    );
    // マルチ商品一覧を再描画
    this.dtg_MultiGoodsList.collectionView.refresh();
  }

  /**
   * コンテキストメニュー作成(候補商品一覧用)
   *
   * @memberof KYMW4701Component
   */
  private createContextMenuForCandidate(): void {
    this.contextForCandidateGoodsList = new Menu(
      document.createElement('div'),
      {
        displayMemberPath: 'caption',
        selectedValuePath: 'cmd',
        itemsSource: [{ caption: '追加', cmd: 'regist', enabled: true }],
        command: {
          canExecuteCommand: param => {
            return param.enabled;
          },
        },
        itemClicked: () => {
          if (this.contextForCandidateGoodsList.selectedValue === 'regist')
            this.regist();
        },
      }
    );
  }

  /**
   * コンテキストメニュー押下処理(候補商品一覧用)
   *
   * @memberof KYMW4701Component
   */
  private regist() {
    this.isEdited = true;
    // 選択した候補商品が既にマルチ商品として存在する場合
    // 【比較対象を「マルチコード」ではなく「Pコード」とした理由】：マルチコードが未設定の候補商品(商品A)をマルチ商品に追加後、再度、
    // 商品Aが追加できてしまうためPコード単位でマルチ商品に存在するかを判断
    const item = this.dtg_CandidateGoodsList.selectedItems[0];
    if (!item) return;

    if (this.model.multiGoodsList.find(_ => item.PCode === _.PCode)) {
      // 追加する候補のpコードが既に商品一覧に存在する場合
      this.dialogService.openAlertGetMessage('W0046');
      return;
    } else if (!item.MultiCode) {
      // 追加する候補のマルチコードが存在しない場合
      this.model.multiGoodsList.push({
        MultiCode: this.model.multiCode,
        CommonCatchcopy: this.model.commonCatchcopy,
        CommonGoodsExplanation: this.model.commonGoodsExplanation,
        PublishSeq: '',
        PCode: item.PCode,
        ApplyTermEnd: item.ApplyTermEnd,
        GuideGoodsName: item.GuideGoodsName,
        GuideStandardName: item.GuideStandardName,
        MakerName: item.MakerName,
        PayeeClient: item.PayeeClient,
        RegistDate: item.RegistDate,
      });
      this.model.multiGoodsList.forEach(
        (e, i) => (e.PublishSeq = (i + 1).toString())
      );
      this.dtg_MultiGoodsList.collectionView.refresh();
    } else if (this.model.multiCode) {
      // マルチコードが存在する場合
      if (this.model.multiCode !== item.MultiCode) {
        // 異なるマルチコードを追加しようとする場合
        this.dialogService.openAlertGetMessage('W0045');
      } else {
        // 同じマルチコードを追加しようとする場合
        this.model.multiGoodsList.push({
          MultiCode: this.model.multiCode,
          CommonCatchcopy: this.model.commonCatchcopy,
          CommonGoodsExplanation: this.model.commonGoodsExplanation,
          PublishSeq: '',
          PCode: item.PCode,
          ApplyTermEnd: item.ApplyTermEnd,
          GuideGoodsName: item.GuideGoodsName,
          GuideStandardName: item.GuideStandardName,
          MakerName: item.MakerName,
          PayeeClient: item.PayeeClient,
          RegistDate: item.RegistDate,
        });
        this.model.multiGoodsList.forEach(
          (e, i) => (e.PublishSeq = (i + 1).toString())
        );
        this.dtg_MultiGoodsList.collectionView.refresh();
      }
    } else {
      // マルチコードが存在しない場合
      this.model.multiCode = item.MultiCode;
      this.getMultiCodeInfoService.execute(this.model, () => {
        const pushGoods: GetMultiGoodsResponse['MultiGoodsList'] = [];
        this.model.candidateGoodsList
          .filter(_ => this.model.multiCode === _.MultiCode)
          .filter(
            _c => !this.model.multiGoodsList.some(_m => _m.PCode === _c.PCode)
          )
          .forEach(_ => {
            pushGoods.push({
              MultiCode: this.model.multiCode,
              CommonCatchcopy: this.model.commonCatchcopy,
              CommonGoodsExplanation: this.model.commonGoodsExplanation,
              PublishSeq: _.PublishSeq,
              PCode: _.PCode,
              ApplyTermEnd: _.ApplyTermEnd,
              GuideGoodsName: _.GuideGoodsName,
              GuideStandardName: _.GuideStandardName,
              MakerName: _.MakerName,
              PayeeClient: _.PayeeClient,
              RegistDate: _.RegistDate,
            });
          });
        this.model.multiGoodsList = pushGoods.concat(this.model.multiGoodsList);
        this.model.multiGoodsList.forEach(
          (e, i) => (e.PublishSeq = (i + 1).toString())
        );
        this.dtg_MultiGoodsList.collectionView.refresh();
      });
    }
  }

  /**
   * 設定ボタンクリックイベント
   *
   * @memberof KYMW4701Component
   */
  public eventCreateTargetListHandler(): void {
    this.isEdited = false;
    // マルチ商品情報が2件未満かつ、「マルチコードが設定されている」場合
    if (this.model.multiGoodsList.length < 2 && this.model.multiCode) {
      this.dialogService.openAlertGetMessage(
        'Q0106',
        ['マルチコード'],
        closeDetail => {
          // OKを押下した場合、画面を閉じる
          if (closeDetail === PlessAlert.Yes) {
            // 選択した行のマルチコードを設定する
            this.deleteMultiGoodsService.execute(this.model, () => {
              this.dialogService.openAlertGetMessage(
                'I0513',
                null,
                closeDetail => {
                  if (closeDetail === PlessAlert.Yes) {
                    this.closeFunction();
                  }
                }
              );
            });
          }
        }
      );
    } else if (this.model.multiGoodsList.length < 2 && !this.model.multiCode) {
      // マルチ商品情報が2件未満かつ、「マルチコードが未登録(新規登録)」の場合
      this.dialogService.openAlertGetMessage('Q0110', null, closeDetail => {
        if (closeDetail === PlessAlert.Yes) {
          this.closeFunction();
        }
      });
    } else {
      // マルチ商品情報登録処理を呼び出す
      this.registMultiGoodsService.execute(this.model, () => {
        this.getCandidateGoodsService.execute(this.model, () => {
          this.dialogService.openAlertGetMessage('I0513');
        });
        this.model.commonCatchcopyOrigin = this.model.commonCatchcopy;
        this.model.commonGoodsExplanationOrigin =
          this.model.commonGoodsExplanation;
      });
    }
  }

  /**
   * 閉じるボタンクリックイベント
   *
   * @memberof KYMW4701Component
   */
  public eventClose_CLICKHandler(): void {
    // 編集が行われている場合、メッセージを表示
    if (this.isEdited || this.model.hasDiff) {
      this.dialogService.openAlertGetMessage('Q0110', null, closeDetail => {
        if (closeDetail === PlessAlert.Yes) {
          this.closeFunction();
        }
      });
    } else {
      this.closeFunction();
    }
  }
}
